import React from 'react';
import PaymentSummaryController from '../../containers/PaymentSummaryController';
import PaymentCalculatorModalController from '../../containers/PaymentCalculatorModalController';

const Loaded = (/* props */) => (
	<div>
		<PaymentSummaryController />
		<PaymentCalculatorModalController name="dynamic" />
	</div>
);

export default Loaded;



// WEBPACK FOOTER //
// ./src/components/views/Loaded.jsx